function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ebe5f2",
  d: "M459.7 71a15 15 0 01-15-6.8c-12-19.2-46-62.2-106.3-48.4C261.7 33.3 249 119 247.7 137.4c-1.4 18.4-13.7 168 97.6 156 0 0 33 59 109.4 22 76.5-36.9 118-93.1 117.8-147.7-.2-52-44-107.4-112.8-96.8"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#dbd0e6",
  d: "M451 78.6s23.3-63.6 37.2-63.8c0 0-21.2-7.8-21.8-14.4-.5-6.6-23 73-20.5 77.6 2.4 4.6 5 .6 5 .6"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#dbd0e6",
  d: "M630.2 67.7s-32.4-81.8-123.7-42.2c0 0-26.4 1.8-31.4 6.8-5.1 5 64-21.8 102.7 11.4 0 0-36.3-21-70.5-12.9 0 0 8.3 23.7 42.8 38 34.4 14.3 75 6 80-1.1M349 297.5s-1.7-6.8-8.8-3.6c-7 3-15.2 9.3-15.7 12-.6 3 5.9-6.3 11-3.4 5 2.8 1 11 1 11s1.5 2.9 6-6c4.5-9 8.5 7.8 8.5 7.8s3.2 4 1.7-5c-1.5-9-4.7-16.5-7.4-16.8"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#f2eef6",
  d: "M248.1 139.5c-4-20-44.8-35.7-60-1.7-15.2 34 47.4 51.6 47.4 51.6s44.2 1.7 51.7-37.3c7.4-39-12.7-77-73.8-111.7-61.1-34.8-154.7 3-179.3 42.5-24.6 39.4-57 121-10.7 158.6 46.3 37.5 67.4 5.3 80.2-9.7 12.8-15 14-50.3-18.7-57.5-32.6-7.2-30.3 42.2-30.3 42.2"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#f2eef6",
  d: "M199.8 151.6c-13.9 24.8 55.8 125.2 55.8 125.2l-109.8 45.5s-23-112-49.2-125.7"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#dbd0e6",
  d: "M103.7 171.1c12.6 41.3-7 23.6-24.6 30.5-17.5 6.9-15.4 39.6-39-5.6-7.6-14.4 3.2-33 20.8-39.8 17.5-6.9 38-.6 42.8 15m145.9-50.8c12.7 41.3-7 23.6-24.5 30.5-17.5 6.8-15.4 39.5-39-5.6-7.6-14.4 3.2-33 20.8-39.9 17.5-6.8 38-.6 42.7 15"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#ebe5f2",
  d: "M370 176.5L161 336c24.4 32.9 65.6 58.9 109.7 58.9 73.9 0 133.8-60 133.8-133.8 0-31.5-16.5-61.8-34.6-84.6z"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#f8f3fc",
  d: "M271.2 282.8l-12 90.6c-.5 3.3 2 6.3 5.3 6.4 24.3 1.3 49.2-4.8 70.9-18.9a5.7 5.7 0 001.4-8.2L281.3 280c-3.1-4-9.5-2.3-10.1 2.7m-15.6-5.9l-72.4 55.5c-2.7 2-3 5.9-.8 8.4a118.4 118.4 0 0063.4 36.7c3.3.7 6.5-1.6 7-5l12-90.3c.6-5-5.2-8.4-9.2-5.3m30.8-.7l55.6 72.6c2 2.7 5.8 3 8.3.8a118.4 118.4 0 0036.8-63.6 5.7 5.7 0 00-4.8-6.8l-90.7-12c-5-.7-8.3 5-5.2 9m6-15.4l90.7 12c3.3.4 6.3-2 6.4-5.3 1.3-24.4-4.8-49.3-18.9-71a5.7 5.7 0 00-8.2-1.4l-72.6 55.6c-4 3-2.3 9.4 2.6 10"
});
var SvgPlaceholder = function SvgPlaceholder(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 630.2 394.9",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlaceholder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/placeholder.1650a495.svg";
export { ForwardRef as ReactComponent };